import {DICT_KEY, getModel, refreshDict, setModel} from "../../../utils/constants";
import ModelUtils from "../../../utils/ModelUtils";
import SupplierService from "./SupplierService";

const MODEL_KEY = DICT_KEY.BASE_SUPPLIER
const storageModel = getModel(MODEL_KEY);
const supplierModel = {
    state: storageModel ? storageModel : {
        searchParam: {},
        supplierList: [],
        pageInfo: {},
        accountList: [],
        selectedSupplier: null,
        selectedSupplierRowKeys: [],
        selectedAccount: null,
        selectedAccountRowKeys: [],

        adjustModelVisible: false,
        fillModelVisible: false,
        transferModelVisible: false,
        tabsKey:null,        
        tabsList:[],
        tabParams:null,
        tabPage:{}
    },

    reducers: {
        setSearchParam(state, payload) {
            state.searchParam = {...payload};
            setModel(MODEL_KEY, {...state});
        },
        setSupplierList(state, payload) {
            state.supplierList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setPageInfo(state, payload) {
            state.pageInfo = payload;
            setModel(MODEL_KEY, {...state});
        },
        setAccountList(state, payload) {
            state.accountList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedSupplier(state, payload) {
            state.selectedSupplier = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedSupplierRowKeys(state, payload) {
            state.selectedSupplierRowKeys = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedAccount(state, payload) {
            state.selectedAccount = payload;
            setModel(MODEL_KEY, {...state});
        },
        setSelectedAccountRowKeys(state, payload) {
            state.selectedAccountRowKeys = payload;
            setModel(MODEL_KEY, {...state});
        },
        setAdjustModelVisible(state, payload) {
            state.adjustModelVisible = payload;
        },
        setFillModelVisible(state, payload) {
            state.fillModelVisible = payload;
        },
        setTransferModelVisible(state, payload) {
            state.transferModelVisible = payload;
        },
        setTabsKey(state,payload){
            state.tabsKey = payload;
        },
        setTabsList(state,payload){
            state.tabsList = payload;
            setModel(MODEL_KEY, {...state});
        },
        setTabParams(state,payload){
            state.tabParams = payload;
            // setModel(MODEL_KEY, {...state});
        },
        setTabPage(state,payload){
            state.tabPage = payload;
        }
    },

    effects: (dispatch) => ({
        async loadSupplierList({showMsg = true, duration = 5, data}) {
            const funName = "加载供应商";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            data.pageSize = data.pageSize || 15
            data.pageNum = data.pageNum|| 1
            const func = async () => {
                let retData = await SupplierService.findPage(data);
                const {list, ...page} = retData;
                list.forEach(el => el.key = el.id);
                this.setSupplierList(list);
                this.setPageInfo(page);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async loadSupplierAccountList({showMsg = true, duration = 5, data}) {
            const funName = "加载供应商账户";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            if (!!data) {
                const func = async () => {
                    let retData = await SupplierService.findAccountAll(data);
                    let {list,statistic} = retData[0]
                    if (list) {
                        list.forEach(el => el.key = el.id);
                    }
                    this.setAccountList(list);
                    return retData
                };
                return await ModelUtils.execute({
                    funName, sucMsg, failMsg, showMsg, duration
                }, func);
            } else {
                this.setAccountList([]);
            }

        },
        async insert({showMsg = true, duration = 5, data}) {
            const funName = "新增供应商";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SupplierService.insert(data);
                const {cmDict} = dispatch;
                await refreshDict("SUPPLIER", cmDict);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        async update({showMsg = true, duration = 5, data},{supplier}) {
            const funName = "更新供应商";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SupplierService.update({...data,supplierStatus: data.supplierStatus ? 0 : 1});   
                const {cmDict} = dispatch;
                await refreshDict("SUPPLIER", cmDict);
                return retData                
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async enableOrDisableSupplier({showMsg = true, duration = 5, data}, {supplier}) {
            const funName = "更新供应商状态";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const {record, checked} = data;
            //调用接口
            const func = async () => {
                let retData = await SupplierService.enableOrDisable({...record, supplierStatus: checked ? 0 : 1});
                const {cmDict} = dispatch;
                await refreshDict("SUPPLIER", cmDict);
                //更新本地数据
                // console.log(retData)
                const {supplierList} = supplier;
                const mapSuppList = supplierList.map(el => {
                    if (el.id === record.id) {
                        return {...el, supplierStatus: checked ? 0 : 1}
                    }
                    return el;
                });
                this.setSupplierList(mapSuppList);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        async enableOrDisableAccount({showMsg = true, duration = 5, data}, {supplier}) {
            const funName = "更新供应商账户状态";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const {id, accountStatus} = data;
            //调用接口
            const func = async () => {
                let retData = await SupplierService.accountEnableOrDisable(data);
                const {cmDict} = dispatch;
                await refreshDict("SUPPLIER", cmDict);
                //更新本地数据
                const {accountList} = supplier;
                const mapAccList = accountList.map(el => {
                    if (el.id === id) {
                        return {...el, accountStatus: accountStatus ? 1 : 0}
                    }
                    return el;
                });
                // console.log(mapAccList)
                this.setAccountList(mapAccList);
                return retData

            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);

        },
        async adjustAccount({showMsg = true, duration = 5, data}, {supplier}) {
            const funName = "调整授信额度";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SupplierService.adjustAccount(data);

                //重新加载供应商账户
                const {selectedSupplier} = supplier;
                await this.loadSupplierAccountList({showMsg: false, data: selectedSupplier.id});
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async fillAccount({showMsg = true, duration = 5, data}, {supplier}) {
            const funName = "账户充值";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SupplierService.fillAccount(data);

                //重新加载供应商账户
                const {selectedSupplier} = supplier;
                await this.loadSupplierAccountList({showMsg: false, data: selectedSupplier.id});
                return retData

            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async transferAccount({showMsg = true, duration = 5, data}, {supplier}) {
            const funName = "账户转账";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            const func = async () => {
                let retData = await SupplierService.transferAccount(data);

                //重新加载供应商账户
                const {selectedSupplier} = supplier;
                await this.loadSupplierAccountList({showMsg: false, data: selectedSupplier.id});
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        async SupplierResizeLimitList({showMsg = true, duration = 5, data}, {customer}) {
            const funName = "调额记录";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            const func = async () => {
                let retData = await SupplierService.SupplierResizeLimitList(data);
                //重新加载客户账户
                let {list,...page} = retData
                // console.log(retData)
                list.forEach(el => el.key = el.id);
                this.setTabsList(list);
                this.setTabPage(page)
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //加载转账记录
        async SupplierTransferAccountsList({showMsg = true, duration = 5, data}, {customer}) {
            const funName = "加载转账记录";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            const func = async () => {
                let retData = await SupplierService.SupplierTransferAccountsList(data);
                //重新加载客户账户
                let {list,...page} = retData
                // console.log(retData)
                list.forEach(el => el.key = el.id);
                this.setTabsList(list);
                this.setTabPage(page)
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },
        //加载充值记录
        async SupplierRechargeList({showMsg = true, duration = 5, data}, {customer}) {
            const funName = "充值记录";
            const sucMsg = funName + "成功!";
            const failMsg = funName + "失败!";
            // return console.log(data)
            const func = async () => {
                let retData = await SupplierService.SupplierRechargeList(data);
                //重新加载客户账户
                let {list,...page} = retData
                // console.log(retData)
                list.forEach(el => el.key = el.id);
                this.setTabPage(page)
                this.setTabsList(list);
                return retData
            };
            return await ModelUtils.execute({
                funName, sucMsg, failMsg, showMsg, duration
            }, func);
        },        
    })
}

export default supplierModel;